var render = function render(){var _vm=this,_c=_vm._self._c;return (this.erosion.length > 0)?_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"chartErosion"}}):_c('span',{staticClass:"secondary&#45;&#45;text text&#45;&#45;lighten-1 textNoData"},[_vm._v(" Sem dados para SIA. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }